var common=require("./common.js");

window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();

Handlebars.registerHelper("color",function(index){
	var t=index%5;
	return colorList[t];
});

Handlebars.registerHelper("fontSize",function(txt){
	if(txt.length<=7){
		return "bigFont";
	}
	return "";
});
var defaultImg=getAbsoluteUrl(require("../img/favicon_b.png"));
Handlebars.registerHelper("head",function(imgKey){
	if(imgKey){
		return imgKey;
	}
	return defaultImg;
});

function getAbsoluteUrl (url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}

var Bullet=require("./Bullet.js");
var comment=require("./comment.js");
var Toast=require("./toast.js");
var myScroll;
var originImgWidth=750;
var originImgHeight=360;    
var bulletScreenHeight=$(".bulletScreen").height();
var bulletScreenWidth=$(".bulletScreen").width();
var fixHeight=bulletScreenWidth/originImgWidth*originImgHeight;
var docEl = document.documentElement;
var fontSize=docEl.style.fontSize;
var gutter=parseInt(fontSize.substr(0,fontSize.length-2))*0.3;
var colorList=[
	"#f09e28","#95a6aa","#ebc42a","#f34f4f","#80b4b5","#f39c12"
]

var $grid;
function loaded () {
	$grid=$('.itemList').masonry({
	  itemSelector: '.item',
	  gutter:gutter
	});
	myScroll = new IScroll('.scrollWrap', { mouseWheel: true ,probeType:3,click:true});
	myScroll.on("scroll",function(){
		if(this.y>fixHeight-bulletScreenHeight){
			$(".bulletScreen").height(this.y+bulletScreenHeight);
			$(".bulletScreen").css({top:0});
		}else{
			$(".bulletScreen").css({top:this.y-fixHeight+bulletScreenHeight});
		}	
		if(this.y<-435/640*bulletScreenWidth){
			$(".tips").hide();
		}else{
			$(".tips").show();
		}
		if(typeof(InnerJSHelper)!="undefined"){
			InnerJSHelper.onScroll(this.y);
		}		
	})
	myScroll.on('scrollEnd', function () {				
	    if ( this.y <=this.maxScrollY) {
	    	main.getCommentList();	        
	    }
	});

	var touchEndPosY=0;
	$(window).bind("touchend",function(){
		touchEndPosY=myScroll.y;
	})
	myScroll.on('scrollEnd', function () {	
	    if ( touchEndPosY >=40){
	    	// window.location.reload();
	    }
	});

}
loaded();

var canvas = document.querySelector("canvas");
var scale=window.devicePixelRatio;
var shareWidth=$(".m-share").width();
var shareHeight=$(".m-share").height();
TweenMax.set($(".m-share"),{scaleX:scale,scaleY:scale,left:0,top:0,transformOrigin:'left top'});
$("canvas").attr("width",shareWidth*scale);
$("canvas").attr("height",shareHeight*scale);
var tycredidential=common.getQueryString("tycredidential");
var bulletList=[];
window.main={
	trajectoryCount:6,
	bulletIndex:0,
	commentOffset:0,
	limit:29,
	itemsListEl:$(".itemList"),
	init:function(){	
		var _this=this;		
		
		if(commentCount>=0){
			this.getBulletList();
		}		
		this.getCommentList();
		this.initEvent();
		if(typeof(CommonJSHelper)=="undefined" && typeof(window.webkit) == "undefined"){
			$(".m-bottomBar").hide();
			$(".m-topic").css({"bottom":"0","top":"1rem"});
			$(".m-topbar").show();
		}
		$(".commentBtn").click(function(){
			if(!isLogined){
				common.login();
				return;
			}
			if(canCommentCount<=0){
				var t=new Toast("今天小主已经表达很深刻了，明天再来吧~");
				return;
			}
			comment.show();
		})

		$(".backBtn").click(function(){
			common.closePage();
		})

		$(".shareBtn").click(function(){
			var title="【天谕话题】"+$(this).data("title");
			var desc=$(this).data("desc");
			var img=$(this).data("img");
			var url=window.location.protocol+"//"+window.location.host+window.location.pathname+"?topicId="+topicId;
			CommonJSHelper.shareWithImageTitleDespUrlTopicId(img,title,desc,url,topicId);
		})

	},
	initEvent:function(){
		var _this=this;
		this.itemsListEl.delegate('.zanBtn', 'click', function(){
			var id=$(this).data("id");
			var hasZan=$(this).attr("data-haszan");
			if(hasZan=="1"){
				_this.zan(id,0);
			}else{
				_this.zan(id,1);
			}			
		});

		this.itemsListEl.delegate('.shareBtn','click',function(){
			var nickname=$(this).data("nickname");
			var content=$(this).data("content");
			var headimg=$(this).data("headimg");
			var zan=$(this).data("zan");
			var color=$(this).data("color");
			var id=$(this).data("id");
			var bigFontClass=false;
			if($(this).hasClass("bigFont")){
				bigFontClass=true;
			}
			_this.share(nickname,content,headimg,zan,color,id,bigFontClass);
		})

		this.itemsListEl.delegate('.mySpaceBtn','click',function(){
			var id=$(this).data("playid");
			CommonJSHelper.showPersonalPageByURS(id);
		})
		$(".bulletScreen,.tips,.m-bottomBar").bind("touchmove",function(e){
			e.preventDefault();
			e.stopPropagation();
		})		

	},
	zan:function(id,type){
		var _this=this;
		// $.getJSON("/yubashuo/zan-comment?commentId="+id+"&type="+type+"&tycredidential="+tycredidential,function(msg){
			
		// })
		$.ajax({
		    url:'/yubashuo/zan-comment',
		    type:'POST',
		    data:{
		        commentId:id,
		        type:type,
		        tycredidential:tycredidential
		    },
		    dataType:'json',
		    success:function(msg){
		    	if(msg.resCode==11){
		    		common.login();
		    		return;
		    	}
		        if(msg.resCode!=0){
					alert(msg.resReason);
					return;
				}
				if(type==0){
					var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
					num=parseInt(num);
					num--;
					$(".zanBtn[data-id="+id+"]").find(".num").html(num);
					$(".zanBtn[data-id="+id+"]").find(".icon-zan").removeClass("icon-zan-1");
					$(".zanBtn[data-id="+id+"]").attr("data-haszan","0");
					$(".bullet[data-id="+id+"]").removeClass("active");
				}
				if(type==1){
					var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
					num=parseInt(num);
					num++;
					$(".zanBtn[data-id="+id+"]").find(".num").html(num);
					$(".zanBtn[data-id="+id+"]").find(".icon-zan").addClass("icon-zan-1");
					$(".zanBtn[data-id="+id+"]").attr("data-haszan","1");
					$(".bullet[data-id="+id+"]").addClass("active");
				}
				_this.changeZan(id,type);
		    },
		    error:function(){
		    	new Toast("网络不可用，请稍后再试！");
		    }
		})
	},
	changeZan:function(id,type){
		for(var i=0;i<bulletList.length;i++){
			if(bulletList[i].commentId==id){
				bulletList[i].hasZan=type;
				break;
			}
		}
	},
	addNewComment:function(html){
		$(".commentBtn.item").after(html);
		$grid.masonry('destroy');
		$grid=$('.itemList').masonry({
			itemSelector: '.item',
			gutter:gutter
		});			
		myScroll.refresh();
	},
	share:function(nickname,content,headimg,zan,color,id,bigFontClass){	
		$(".m-share").show();
		var c="";
		var l=10;
		if(content.length>10){
			for(var i=0;i<content.length;i+=10){
				c+=content.substr(i,10)+"<br>";
			}
			$(".m-share .info").html(c);
		}else{
			$(".m-share .info").html(content);
		}				
		$(".m-share .count").html(zan);
		// $(".m-share .headImg").attr("src",headimg);
		$(".m-share .author").html("by "+nickname);
		$(".m-share .bgColor").css({"background":color});
		if(bigFontClass){
			$(".m-share .info").addClass("bigFont");
		}else{
			$(".m-share .info").removeClass("bigFont");
		}
		html2canvas(document.querySelector(".m-share"), {
			canvas: canvas,
			useCORS:true,
			letterRendering:true
		}).then(function(canvas) {	        
			var url=window.location.protocol+"//"+window.location.host+window.location.pathname+"?topicId="+topicId;
	        var qrcode	= new QRCode(-1, 1);
			qrcode.addData(url);
			qrcode.make();

			var options	= $.extend( {}, {
				render		: "canvas",
				width		: 256,
				height		: 256,
				typeNumber	: -1,
				correctLevel	: QRErrorCorrectLevel.H,
	                        background      : "#ffffff",
	                        foreground      : "#000000"
			}, options);

			// create canvas element
			var canvas	=$("canvas")[0];
			var ctx		= canvas.getContext('2d');
			options.width=84/640*canvas.width;
			options.height=84/640*canvas.width;
			// compute tileW/tileH based on options.width/options.height
			var tileW	= options.width  / qrcode.getModuleCount();
			var tileH	= options.height / qrcode.getModuleCount();
			var startX=canvas.width-100/640*canvas.width;
			var startY=canvas.height-100/820*canvas.height;
			// draw in the canvas
			for( var row = 0; row < qrcode.getModuleCount(); row++ ){
				for( var col = 0; col < qrcode.getModuleCount(); col++ ){
					ctx.fillStyle = qrcode.isDark(row, col) ? options.foreground : options.background;
					var w = (Math.ceil((col+1)*tileW) - Math.floor(col*tileW));
					var h = (Math.ceil((row+1)*tileW) - Math.floor(row*tileW));
					ctx.fillRect(startX+Math.round(col*tileW),startY+Math.round(row*tileH), w, h);  
				}	
			}

			var myImage = canvas.toDataURL("image/png");
	        var url=window.location.protocol+"//"+window.location.host+window.location.pathname+"?topicId="+topicId;
	        var desc=topicTitle+url;
	        CommonJSHelper.shareImageWithCommentId(myImage,desc,id);
	        // window.open(myImage);
	        $(".m-share").hide();
	    });
	},
	getBulletList:function(){
		var _this=this;
		// get-bullet-comment-list
		if(typeof(CommonJSHelper)=="undefined"){
			return;
		}
		$.getJSON("/yubashuo/get-bullet-comment-list?topicId="+topicId+"&offset=0&limit=100&tycredidential="+tycredidential,function(msg){
			if(msg.resCode!=0||!msg.data){
				return;
			}
			bulletList=msg.data;
			for(var i=0;i<_this.trajectoryCount;i++){
				_this.addNewBullet(i);
				_this.getBulletIndex();
			}
		})
	},
	getCommentList:function(){
		var _this=this;
		if(this.commentOffset>commentCount-1){
			return;
		}
		$.getJSON("/yubashuo/get-comment-list?topicId="+topicId+"&offset="+this.commentOffset+"&limit="+this.limit+"&tycredidential="+tycredidential,function(msg){
			if(msg.resCode!=0){
				console.log(msg.resReason);
				return;
			}
			var source=$("#commentItem-template").html();
			var template=Handlebars.compile(source);
			var html=template({items:msg.data});
			$(".itemList").append(html);
			$grid.masonry('destroy');
			$grid=$('.itemList').masonry({
				itemSelector: '.item',
				gutter:gutter
			});			
			myScroll.refresh();
			if(msg.data){
				_this.commentOffset+=msg.data.length;
			}	
			_this.limit=20;	
		})
	},
	addNewBullet:function(trajectory){
		var b=new Bullet(bulletList[this.bulletIndex],trajectory);
		this.getBulletIndex();
	},
	getBulletIndex:function(){
		if(this.bulletIndex==bulletList.length-1){
			return this.bulletIndex=0;
		}else{
			return this.bulletIndex++;
		}
	}
}
main.init();
comment.init();






//////////////////
// WEBPACK FOOTER
// ./pages/yubashuo/js/topic.js
// module id = 0
// module chunks = 2